import { getSelectedOrganizationId } from '../../../selectors/organizations/organizations';
import { getProjects } from '../project';

import {
  buildLoadDataCachedFn,
  fetchDataOnOrganizationChange,
} from './utils/utils';

const loadData = (context, dispatch, getState) => {
  const state = getState();
  const organizationId = getSelectedOrganizationId(state, { router: context });

  if (!organizationId) {
    return Promise.reject({
      code: 404,
    });
  }

  return getProjects(organizationId)(dispatch);
};

const loadDataCached = buildLoadDataCachedFn(
  loadData,
  fetchDataOnOrganizationChange,
);

export const getProjectsData = (context) => (dispatch, getState) => {
  return loadDataCached(context, dispatch, getState);
};
